import React, { createContext, useContext } from 'react';
import ToastContainer from './ToastContainer';
import { useToast } from '../hooks/useToast';

const ToastContext = createContext(null);

/**
 * ToastProvider Component
 * Provides toast functionality to the app
 */
export const ToastProvider = ({ children }) => {
  const toast = useToast();

  return (
    <ToastContext.Provider value={toast}>
      {children}
      <ToastContainer toasts={toast.toasts} removeToast={toast.removeToast} />
    </ToastContext.Provider>
  );
};

/**
 * useToastContext Hook
 * Access toast functions from context
 */
export const useToastContext = () => {
  const context = useContext(ToastContext);
  if (!context) {
    throw new Error('useToastContext must be used within ToastProvider');
  }
  return context;
};

export default ToastProvider;
